import { ChatText, Phone } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { business } from '../content/site';

export function MobileActions() {
  return (
    <div className="mobile-actions" aria-label="Quick contact actions">
      <a href={business.phoneHref}><Phone aria-hidden="true" size={19} weight="fill" /> Call</a>
      <Link to="/contact"><ChatText aria-hidden="true" size={19} weight="fill" /> Request an Estimate</Link>
    </div>
  );
}

